import React from 'react';
import {goRoute} from '../common/js'
import LoadMore from '../common/LoadMore'
import util from "../../util/tools";
import commonTools from "../../../common/util/util";
import './index.css';
import Arrow from '../../../common/images/arrow_r.png'
import Header from "../common/Header";
import ActivityPopup from '../common/ActivityPopup'

export default class Home extends React.Component {
    constructor() {
        super();
        this.state = {
            page: 1,
            isShowAll: true,
            site:1,//1男生，2 女生，3出版
            progress:[],//连载状态
            currentProgress:1000,
            currentProgressName:"全部",
            wordCounts:[],//字数分类
            currentWord:1000,
            currentWordName:"全部",
            bookTypes:[],//分类
            currentType:1000,
            currentTypeName:"全部",
            loadMoreType:0,
            bookLists:[],
            isLoad:false,
            showPopup: false,
            popupId: null,
            activityUrl: '',
            activityId: ''
        };

        this.getCateInfo = this.getCateInfo.bind(this);
    }

    componentDidMount() {
        document.title = "分类";
        let str = commonTools.searchPar()
        if(!!str.site){
            this.setState({
                site: str.site,
                currentType: str.category_id
            },()=>{
                let fun = null;
                if(!!str.category_id){
                    fun = ()=>this.getBookLists();
                }
                this.getCateInfo(fun);
            });
        }else{
            let site = 1;//男频
            if(commonTools.cnzzData.property == 2){
                site = 2;//女频
            }
            this.setState({
                site: site
            },()=>{
                this.getCateInfo();
            });
        }
        this.checkPopup()
    }
    // 默认推荐书籍
    defaultData(){
        let re_cid = this.state.site==1?140:this.state.site==2?141:this.state.site==3?142:'';
        let num = 20;
        util.ajax({
            url: "/zh/book/ranking",
            isUser: true,
            isWechatId: true,
            data: {
                're_cid':re_cid,
                'num':num,
                'page':this.state.page
            },
            callback: res => {
                if (res.result.status.code == 0) {
                    let json = res.result.data;
                    if(json.length>=num || this.state.page == 1){
                        this.setState({
                            isLoad: true
                        })
                    }
                    let tempObj = {
                        page: this.state.page+1,
                        bookLists: this.state.bookLists.concat(json)
                    };
                    if(this.state.bookLists.length<=0){
                        tempObj.page = 1;
                        tempObj.loadMoreType = 1;
                    }

                    this.setState(tempObj,()=>{
                        if(this.state.bookLists.length<=0){
                            // 没有推荐书籍，则调用筛选列表
                            this.getBookLists(1);
                        }
                    })
                }
            }
        });
    }
    // 分类
    getCateInfo(callback){
        util.ajax({
            url: "/zh/book/bookCateInfo",
            isUser: true,
            data: {
                'site': this.state.site
            },
            callback: res => {
                if (res.result.status.code == 0) {
                    let json = res.result.data;
                    let tempObj = {
                        progress: json.writing_process,
                        currentProgress: json.writing_process[0].id,
                        currentProgressName: json.writing_process[0].name,
                        wordCounts: json.word_count,
                        currentWord: json.word_count[0].id,
                        currentWordName: json.word_count[0].name,
                        bookTypes : json.categoryList,
                        currentType: json.categoryList[0].id,
                        currentTypeName: json.categoryList[0].name,
                        loadMoreType: 1
                    };
                    if(!!callback){
                        json.categoryList.forEach(item=>{
                            if(item.id == this.state.currentType){
                                tempObj.currentType = item.id;
                                tempObj.currentTypeName = item.name;
                            }
                        });
                    }
                    this.setState(tempObj,()=>{
                        if(!!callback){
                            callback();
                        }else{
                            this.defaultData();
                        }
                    })
                }
            }
        });
    }
    // 切换男女频
    changeSite(index){
        this.setState({
            page: 1,
            site:index,
            bookLists: [],
            isLoad:false
        },()=>{
            this.getCateInfo()
        })
    }

    // 筛选列表
    getBookLists(page){
        let num = 12;
        util.ajax({
            url: "/zh/book/bookFilter",
            isUser: true,
            data: {
                'site': this.state.site,
                'word_count_id': this.state.currentWord,
                'writing_process_id': this.state.currentProgress,
                'category_id': this.state.currentType,
                'num':num,
                'page':page || this.state.page
            },
            callback: res => {
                if (res.result.status.code == 0) {
                    let json = res.result.data;
                    if(json.length >= num){
                        this.setState({
                            isLoad: true
                        })
                    }
                    this.setState({
                        page: this.state.page + 1,
                        bookLists: this.state.bookLists.concat(json)
                    })
                }
            }
        });
    }

    showBox(){
        this.setState({
            isShowAll : !this.state.isShowAll
        })
    }
    selectBookList(item,type){
        let tempObj = {
            page: 1,
            bookLists: [],
            isLoad:false,
            isShowAll:!this.state.isShowAll
        };
        tempObj[type] = item.id;
        tempObj[type+"Name"] = item.name;
        this.setState(tempObj,()=>{
            this.setState({
                loadMoreType:1,
            },()=>{
                this.getBookLists(1)
            });
        });
    }

    // 判断是否有活动弹窗
    checkPopup() {
        const date = new Date()
        const fullYear = date.getFullYear()
        const month = date.getMonth()
        const day = date.getDate()
        const fullDate = `${fullYear}-${month+1}-${day}`
        const oldDate = localStorage.popupDate5
        util.ajax({
            url: '/zh/activity/activitypopup',
            data:{
                popup_id: 5
            },
            callback: res => {
                // console.log(res)
                if (res.result.status.code == 0 && res.result.data.length) {
                    const data = res.result.data[0]
                    this.setState({
                        popupId: data.temp_id,
                        activityUrl: data.activity_url,
                        activityId: data.id
                    })
                    if (!oldDate) {
                        this.setState({
                            showPopup: true
                        })
                        localStorage.popupDate5 = fullDate
                    } else if (oldDate && fullDate != oldDate ) {
                        this.setState({
                            showPopup: true
                        })
                        localStorage.popupDate5 = fullDate
                    } else {
                        this.setState({
                            showPopup: false
                        })
                    }
                }
            }
        })
    }

    // 关闭弹窗
    closePopup = () => {
        this.setState({
            showPopup: false
        })
    }

    render() {
        return (
            <div className='cg_wrapper'>
                <div className='topBox'>
                    <Header />
                    <div className='tab'>
                        <div className={`tab_single ${this.state.site == 2? 'tab_singleColor':''}`} onClick={()=>this.changeSite(2)}>女生</div>
                        <div className={`tab_single ${this.state.site == 1? 'tab_singleColor':''}`} onClick={()=>this.changeSite(1)}>男生</div>
                        {/* <div className={`tab_single ${this.state.site == 3? 'tab_singleColor':''}`} onClick={()=>this.changeSite(3)}>出版</div> */}
                    </div>
                    {
                        this.state.isShowAll && this.state.progress.length>0 && this.state.wordCounts.length>0 && this.state.bookTypes.length>0 &&
                        <div className='thrItems' onClick={()=>this.showBox()}>
                            <div className='thrItems_cont'>
                                <span className='thrItems_cont_single'>{this.state.currentProgressName}</span>
                                <div className='thrItems_cont_singleLine'></div>
                                <span className='thrItems_cont_single'>{this.state.currentWordName}</span>
                                <div className='thrItems_cont_singleLine'></div>
                                <span className='thrItems_cont_single'>{this.state.currentTypeName}</span>
                            </div>
                            <img className='thrItems_Arrow' src={Arrow} alt=""/>
                        </div>
                    }
                </div>
                {
                    !this.state.isShowAll && 
                    <div className='cover1'>
                        <div className='thrItemsAll'>
                            <div className='thrItemsAll_single thrItemsAll_singleSerialize'>
                                <div className='thrItemsAll_single_l'>连载</div>
                                <div className='thrItemsAll_single_r'>
                                    {
                                        !!this.state.progress && this.state.progress.length>0 && this.state.progress.map((item, index) => {return  <span key={`cg_${index}1`} className={`thrItemsAll_single_r_single ${this.state.currentProgress == item.id?' addColor':''}`} onClick={()=>this.selectBookList(item,'currentProgress')}>{item.name}</span>})
                                    }
                                </div>
                            </div>
                            <div className='thrItemsAll_single thrItemsAll_singleFont'>
                                <div className='thrItemsAll_single_l'>字数</div>
                                <div className='thrItemsAll_single_r'>
                                    {
                                        !!this.state.wordCounts && this.state.wordCounts.length>0 && this.state.wordCounts.map((item, index) => {return   <span key={`cg_${index}1`} onClick={()=>this.selectBookList(item,'currentWord')} className={`thrItemsAll_single_r_single ${this.state.currentWord == item.id?'addColor':''}`}>{item.name}</span>})
                                    }
                                </div>
                            </div>
                            <div className='thrItemsAll_single thrItemsAll_singleFont'>
                                <span className='thrItemsAll_single_l'>类型</span>
                                <div className='thrItemsAll_single_r'>
                                    {
                                        !!this.state.bookTypes && this.state.bookTypes.length>0 && this.state.bookTypes.map((item, index) => {return <span key={`cate_${index}_type`} onClick={()=>this.selectBookList(item,'currentType')} className={`thrItemsAll_single_r_single ${this.state.currentType == item.id?'addColor':''}`}>{item.name}</span>})
                                    }
                                </div>
                            </div>
                            <div className='thrItemsAll_close' onClick={()=>this.showBox()}>
                                <img className='thrItemsAll_close_arrow' src={Arrow} alt=""/>
                            </div>
                        </div>
                    </div>
                }
                <div className='books'>
                    {
                        !!this.state.bookLists && this.state.bookLists.length>0 && 
                        this.state.bookLists.map((item,index) => {
                            return (
                                <div className='books_single' key={`bookList${index}`} onClick={()=>goRoute(this.props,item.book_id,0)}>
                                    <img className='books_single_l' src={item.cover_url} alt=""/>
                                    <div className='books_single_r'>
                                        <span className='books_single_r_title text-overflow'>{item.book_title}</span>
                                        <span className='books_single_r_author text-overflow'>{item.author_name}/{(item.word_count/10000).toFixed(1)}万字</span>
                                        <div className='books_single_r_intro text-overflow2'>{(item.book_intro_1)}</div>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
                {this.state.isLoad && this.state.loadMoreType ==0 && <LoadMore loadMoreData={()=>this.defaultData()}/>}
                {this.state.isLoad && this.state.loadMoreType ==1 && <LoadMore loadMoreData={()=>this.getBookLists()}/>}
                {
                    this.state.showPopup &&
                    <ActivityPopup
                        popupId={this.state.popupId} activityUrl={this.state.activityUrl}
                        activityId={this.state.activityId} closePopup={this.closePopup}>
                    </ActivityPopup>
                }
            </div>
        );
    }
}